import { Outlet } from "react-router-dom";

const MainInvoiceOut = () => {
    return(
        <div className="w-full h-full">
            <Outlet/>
        </div>
    )
}
export default MainInvoiceOut;